import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import classNames from "classnames";
import { useIsUIVisible, useSetIsUIVisible } from "../../../VideoContextProvider/context/state/isUIVisible.js";
function Backdrop() {
  const backdropRef = useRef(
    /** @type {HTMLDivElement | null} */
    null
  );
  const isUIVisible = useIsUIVisible();
  const { showUIThenHide, hideUIImmediately } = useSetIsUIVisible();
  useEffect(() => {
    var _a;
    function touchListener(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUIVisible) {
        hideUIImmediately();
        return;
      }
      showUIThenHide();
    }
    const container = backdropRef == null ? void 0 : backdropRef.current;
    (_a = container == null ? void 0 : container.addEventListener) == null ? void 0 : _a.call(container, "touchstart", touchListener);
    return () => {
      var _a2;
      (_a2 = container == null ? void 0 : container.removeEventListener) == null ? void 0 : _a2.call(container, "touchstart", touchListener);
    };
  }, [hideUIImmediately, isUIVisible, showUIThenHide]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("omega_controlRackBackdrop", {
        omega_uiVisible: isUIVisible
      }),
      ref: backdropRef
    }
  );
}
export {
  Backdrop
};
//# sourceMappingURL=index.js.map
